import axios from "axios";
import { backend_url } from "../../utils/config.js";

const state = {
  clients: [],
  totalClients: 0,
  currentPage: 1,
  totalPages: 1,
  allClientsForFilters: [],
};

const getters = {
  getClients: (state) => state.clients,
  getTotalClients: (state) => state.totalClients,
  getCurrentClientPage: (state) => state.currentPage,
  getTotalClientPages: (state) => state.totalPages,
  getAllClientsForFilters: (state) => state.allClientsForFilters,
};

const actions = {
  CLIENTS_REQUEST: ({ commit }, params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {
          page = 1,
          limit = 25,
          search = "",
        } = params;

        const queryParams = new URLSearchParams({
          page: page.toString(),
          limit: limit.toString(),
          ...(search && { search }),
        });

        const { data } = await axios.get(
          `${backend_url}/client?${queryParams.toString()}`
        );
        commit("GET_CLIENTS", {
          clients: data.clients,
          total: data.total,
          page: data.page,
          totalPages: data.totalPages,
        });
        resolve(data);
      } catch (err) {
        commit("CLIENT_ERROR");
        reject(err);
      }
    });
  },
  CLIENTS_REQUEST_LIGHTWEIGHT: ({ commit }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${backend_url}/client/list`);
        commit("GET_ALL_CLIENTS_FOR_FILTERS", data);
        resolve(data);
      } catch (err) {
        commit("CLIENT_ERROR");
        reject(err);
      }
    });
  },
  ADD_CLIENT: ({ commit }, client) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.post(`${backend_url}/client`, client);
        resolve(data);
      } catch (err) {
        commit("CLIENT_ERROR");
        err.response
          ? reject(err.response.data.details.join())
          : reject(
              "Erreur du serveur. Il se peut que ce soit un problème de connexion"
            );
      }
    });
  },
  FETCH_CLIENT: ({ commit }, _id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.get(`${backend_url}/client/${_id}`);
        resolve(data);
      } catch (err) {
        commit("CLIENT_ERROR");
        reject(err);
      }
    });
  },
  DELETE_CLIENT: ({ commit }, { _id }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.delete(`${backend_url}/client/${_id}`);
        commit("UPDATE_DELETED_CLIENTS", _id);
        resolve(data);
      } catch (err) {
        commit("CLIENT_ERROR");
        reject(err);
      }
    });
  },
  UPDATE_CLIENT: ({ commit }, { _id, payload }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await axios.patch(
          `${backend_url}/client/${_id}`,
          payload
        );
        commit("UPDATE_UPDATED_CLIENTS", { _id, payload });
        resolve(data);
      } catch (err) {
        commit("CLIENT_ERROR");
        reject(err);
      }
    });
  },
};

const mutations = {
  UPDATE_UPDATED_CLIENTS: (state, { _id, payload }) => {
    const list = state.clients.map((elem) => {
      if (elem._id == _id) {
        return {
          ...elem,
          ...payload,
        };
      }
      return elem;
    });

    state.clients = list;
  },
  UPDATE_DELETED_CLIENTS: (state, id) => {
    state.clients = state.clients.filter((client) => client._id !== id);
    state.totalClients = state.totalClients > 0 ? state.totalClients - 1 : 0;
  },
  GET_CLIENTS: (state, { clients, total, page, totalPages }) => {
    state.clients = clients;
    state.totalClients = Number(total) || 0;
    state.currentPage = Number(page) || 1;
    state.totalPages = Number(totalPages) || 1;
  },
  GET_ALL_CLIENTS_FOR_FILTERS: (state, clients) => {
    // Set all clients for dropdowns/filters (lightweight list)
    state.allClientsForFilters = Array.isArray(clients) ? clients : [];
  },
  CLIENT_ERROR: (state) => {
    state.clients = [];
    state.totalClients = 0;
    state.currentPage = 1;
    state.totalPages = 1;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
